var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFan(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14.94 14.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-1, .cls-2 {\n        stroke: #02222B;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .cls-2 {\n        fill: none;\n        stroke-width: 1.25px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m8.12,8.65c-.2.18-.47.29-.76.29s-.56-.11-.76-.29c-1.13,2.37-4.14,2.7-3.73,3.94.44,1.31,3.82,2.06,4.86,1.58,1.13-.52.57-4.28.46-5.52h-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m8.65,6.78c.18.2.29.47.29.76s-.11.56-.29.76c2.37,1.13,2.7,4.14,3.94,3.73,1.31-.44,2.06-3.82,1.58-4.86-.52-1.13-4.28-.57-5.52-.46v.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m6.29,8.16c-.18-.2-.29-.47-.29-.76s.11-.56.29-.76c-2.37-1.13-2.7-4.14-3.94-3.73-1.31.44-2.06,3.82-1.58,4.86.52,1.13,4.28.57,5.52.46v-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m6.76,6.29c.2-.18.47-.29.76-.29s.56.11.76.29c1.13-2.37,4.14-2.7,3.73-3.94-.44-1.31-3.82-2.06-4.86-1.58-1.13.52-.57,4.28-.46,5.52h.08Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 7.48,
    cy: 7.5,
    r: 1.47
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFan);
export default __webpack_public_path__ + "static/media/icon_fan.142908e6512c7bda51ebef9c6cc5bd08.svg";
export { ForwardRef as ReactComponent };